//hamburger menu
function createHamburgerMenu () {

  var $win = $(window);
  var ww = window.innerWidth;
  var currentWidth = window.innerWidth;
  var breakpoint = 1024;

  // ---  横幅が変動した時に実行
//  $win.on('load', function () {
    checkGnavWidth();
//  });

  window.addEventListener("resize", function () {
    // ウインドウ横幅が変わっていない場合
    if ( currentWidth == window.innerWidth ) {
      return false;
    }
    checkGnavWidth();
    currentWidth = window.innerWidth; // 横幅を更新

  });

  // -- toggle action
  $('#toggle').on('click', function () {
    $(this).toggleClass('active');
    $('html').toggleClass('open');

    if ( $(this).hasClass('active') ) {
      $('#gnavi').addClass('active');
    } else {
      $('#gnavi').removeClass('active');
    }

    $('#gnavi').slideToggle( function () { // iOSバグ対策
      if( $(this).hasClass('active') ) {
        $(this).css('display','block');
      } else {
        //監視解除
        $(this).css('display','none');
      }
    });

  });

  // --- dropdown menu
  function drop_down() {
    if ( ww > breakpoint ) {
      $('#gnavi ul li.drop_down').on({
        'mouseenter' : function () {
          $(this).addClass('active');
        },
        'mouseleave' : function () {
          $(this).removeClass('active');
        }
      });
    } else {
      $('#gnavi ul li.drop_down').on('click', function () {
        $(this).toggleClass('active');
        $('>a + .drop_down_menu',this).slideToggle();
      });
    }
  }

  function checkGnavWidth () {
    ww = window.innerWidth;
    globalNavInit();
    drop_down();
  }

  // --- リサイズ時の初期化
  function globalNavInit () {
    if ( ww <= breakpoint ) {
      $('#gnavi').hide();
      $('#gnavi').removeClass('active');
      $('#gnavi > ul > li.drop_down .drop_down_menu').hide();
    } else {
      $('#gnavi').show();
      $('#gnavi > ul > li.drop_down .drop_down_menu').show();
    }
    $('#toggle').removeClass('active');
    $('html').removeClass('open');
    $('#gnavi > ul > li.drop_down > a').removeClass('active');
    $win.off('scroll');
    $('#gnavi ul li.drop_down').off('click');
  }



  //サブナビ
  var activeClassName = 'active';
  var regex = new RegExp(/index\.(html|php)/);
  var path = location.pathname.replace(regex, '');
  var gnaviitemLinks = $("#localNavi").find('a');

  $(function(){
      gnaviitemLinks.each(function(){
          var replacedHref = $(this).attr("href").replace(regex, "");

          if(path == replacedHref) {
              $(this).addClass(activeClassName);
          }
      });

  });





  $(function(){

    if (window.matchMedia( "(max-width: 1024px)" ).matches) {


         var query = window.location.search.slice(1);

         var reg = /=/; if(query.length > 0 && ! reg.test(query)){ var q = $('#'+query); if(q.length < 1) return;
          q.addClass('open');
           var ofs = q.offset(); ofs = ofs.top; $('html, body').animate({scrollTop: ofs}, 1000); }
           $('#localNavi').on('click',
           function(event){ if($(this).hasClass('open')){
              $(this).removeClass('open');
            }
            else{
              $(this).addClass('open');
            }
          });
    }

  });




}

